import React from "react";

export const FilterContext = React.createContext();

export default function FilterProvider({ children }) {
  const [filter, setFilter] = React.useState({});

  return <FilterContext.Provider value={{ filter, setFilter }}>{children}</FilterContext.Provider>;
}
